export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12402.60fe9f33.jpg";